var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCateHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 7,
    fill: "#DCFCE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.49466 14.8357L5.93712 11.5145C5.85444 11.4377 5.77569 11.355 5.70284 11.2703H7.41566C7.86059 11.2703 8.26222 11.0026 8.4335 10.5911L8.64022 10.095L9.61081 12.2508C9.68563 12.4181 9.84903 12.5264 10.0321 12.5284C10.2152 12.5303 10.3826 12.4299 10.4653 12.2665L11.3 10.595L11.3335 10.662C11.5205 11.036 11.9024 11.2723 12.3198 11.2723H14.3772C14.3043 11.357 14.2256 11.4396 14.1429 11.5164L10.5853 14.8357C10.4377 14.9735 10.2428 15.0503 10.04 15.0503C9.83722 15.0503 9.64231 14.9735 9.49466 14.8357ZM14.9166 10.3253H12.3178C12.2588 10.3253 12.2037 10.2919 12.1761 10.2387L11.7193 9.32717C11.6386 9.16771 11.4752 9.06533 11.2961 9.06533C11.1169 9.06533 10.9535 9.16574 10.8728 9.32717L10.0577 10.9573L9.05366 8.71489C8.97687 8.54361 8.80362 8.43336 8.61659 8.4373C8.42956 8.44124 8.26025 8.55345 8.18741 8.72867L7.56134 10.2308C7.53772 10.2899 7.47866 10.3273 7.41566 10.3273H5.315C5.26381 10.3273 5.21656 10.3352 5.17128 10.349C5.05906 10.034 5 9.69927 5 9.35867V9.24449C5 7.86833 5.99422 6.69496 7.35069 6.46855C8.24844 6.31892 9.16194 6.61227 9.80375 7.25408L10.04 7.49033L10.2762 7.25408C10.9181 6.61227 11.8316 6.31892 12.7293 6.46855C14.0858 6.69496 15.08 7.86833 15.08 9.24449V9.35867C15.08 9.69139 15.0249 10.0182 14.9166 10.3253Z",
    fill: "#22C55E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.08,
    height: 10.08,
    fill: "white",
    transform: "translate(5 5.6001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCateHealth);
export default __webpack_public_path__ + "static/media/icon-cate-health.e729b837459a52ed7b270d29f8d44a3a.svg";
export { ForwardRef as ReactComponent };